import textEditorConstants from "../constants/textEditorConstants";

export const clearTextEditorState = () => {
	return (dispatch) => {
		dispatch({
			type: textEditorConstants.CLEAR_STATE,
		});
	};
};
